import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageTypes } from '@app/shared/ui-components';
import emailjs from '@emailjs/browser';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent implements OnInit {
  /** Contact form */
  contactForm!: FormGroup;
  /** Loading */
  loading = false;
  /** Cities */
  cities: string[] = [];
  /** Submitting */
  submitting = false;
  /** Toast message */
  toastMessage = '';
  /** Type toast message */
  typeToastMessage = '';
  /** show toast message */
  showToastMessage = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      subject: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
      message: ['', Validators.required],
    });

    this.cities = this.cities.sort();
  }

  validateForm(): boolean {
    if (this.contactForm.controls.name.invalid) {
      this.contactForm.controls.name.markAsDirty();

      return false;
    }
    if (this.contactForm.controls.email.invalid) {
      this.contactForm.controls.email.markAsDirty();

      return false;
    }
    if (this.contactForm.controls.subject.invalid) {
      this.contactForm.controls.subject.markAsDirty();

      return false;
    }
    if (this.contactForm.controls.message.invalid) {
      this.contactForm.controls.message.markAsDirty();

      return false;
    }

    return true;
  }

  sendEmail() {
    if (this.validateForm()) {
      this.loading = true;
      const templateParams = {
        name: this.contactForm.controls.name.value,
        email: this.contactForm.controls.email.value,
        subject: this.contactForm.controls.subject.value,
        message: this.contactForm.controls.message.value,
      };

      emailjs.send('service_ya8drll', 'template_xmsa33v', templateParams, 'user_Fy44hWrTBFAJ9JBxzLDEA').then(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.typeToastMessage = MessageTypes.SUCCESS;
            this.toastMessage = 'Gracias por ponerte en contacto con nosotros. En breve, nos comunicaremos contigo.';
            this.showToastMessage = true;
            this.contactForm.reset();
          }
        },
        err => {
          this.loading = false;
          this.typeToastMessage = MessageTypes.ERROR;
          this.toastMessage = err.text;
          this.showToastMessage = true;
          this.contactForm.reset();
        }
      );
    }
  }
}
